import { type PutApiPurewaveSettingMutationRequest } from '@/shared/api'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { combine, createEvent, sample } from 'effector'
import { createGate } from 'effector-react'

import { myWaveQuery, myWaveUpdate } from '../api/my-wave.api'

export const MyWaveGate = createGate()

export const myWaveSettingsUpdated = createEvent<{
  data?: PutApiPurewaveSettingMutationRequest
}>()

export const $queryLoading = combine(
  {
    pending: myWaveQuery.$pending,
    data: myWaveQuery.$data,
    error: myWaveQuery.$error,
  },
  ({ pending, data, error }) => pending || (!data && !error),
)

export const $updateLoading = myWaveUpdate.$pending

sample({
  clock: myWaveSettingsUpdated,
  target: myWaveUpdate.start,
})

sample({
  clock: MyWaveGate.open,
  fn: () => {},
  target: myWaveQuery.start,
})
sample({
  clock: MyWaveGate.close,
  target: myWaveQuery.reset,
})

sample({
  clock: myWaveUpdate.finished.success,
  fn: () => {
    return {
      message: 'Настройки чистой волны обновлены',
    }
  },
  target: [showNotificationSuccessFx, myWaveQuery.start],
})
